function initSlider(sectionSelector, listSelector, prevSelector, nextSelector, dotsSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const list = section.querySelector(listSelector);
  const prevBtn = section.querySelector(prevSelector);
  const nextBtn = section.querySelector(nextSelector);
  const dotsContainer = section.querySelector(dotsSelector);

  if (!list) return;

  const items = list.children;
  const totalSlides = items.length;
  let current = 0;

  // Налаштування індикатора прогресу (смужки)
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    // Створюємо один елемент лінії-індикатора всередині контейнера
    const progressLine = document.createElement('div');
    progressLine.classList.add('progress-line');

    // Задаємо ширину індикатора відповідно до кількості слайдів (наприклад, для 5 слайдів це 20%)
    progressLine.style.width = `${100 / totalSlides}%`;
    dotsContainer.appendChild(progressLine);
  }

  // Відстеження ручного скролу
  list.addEventListener('scroll', () => {
    const gap = parseInt(getComputedStyle(list).gap) || 0;
    const stepWidth = items[0].offsetWidth + gap;
    const newIndex = Math.round(list.scrollLeft / stepWidth);

    if (newIndex !== current && newIndex >= 0 && newIndex < totalSlides) {
      current = newIndex;
      updateProgress();
    }
  });

  // Функція оновлення положення смужки
  function updateProgress() {
    if (!dotsContainer) return;
    const progressLine = dotsContainer.querySelector('.progress-line');
    if (!progressLine) return;

    // Рахуємо крок зміщення у відсотках (наприклад, для 5 слайдів крок 20%)
    const stepPercent = 100 / totalSlides;
    progressLine.style.left = `${stepPercent * current}%`;
  }

  function scrollToSlide() {
    const gap = parseInt(getComputedStyle(list).gap) || 0;
    const stepWidth = items[0].offsetWidth + gap;

    list.scrollTo({
      left: stepWidth * current,
      behavior: 'smooth'
    });

    updateProgress();
  }

  const scroll = (direction) => {
    const max = totalSlides - 1;
    if (direction === 'next') {
      current = (current < max) ? current + 1 : 0;
    } else {
      current = (current > 0) ? current - 1 : max;
    }
    scrollToSlide();
  };

  // Автопрокрутка
  let autoScroll = setInterval(() => scroll('next'), 5000);

  section.addEventListener('mouseenter', () => clearInterval(autoScroll));
  section.addEventListener('mouseleave', () => {
    autoScroll = setInterval(() => scroll('next'), 5000);
  });

  list.addEventListener('touchstart', () => clearInterval(autoScroll), {passive: true});

  if (nextBtn) nextBtn.addEventListener('click', () => scroll('next'));
  if (prevBtn) prevBtn.addEventListener('click', () => scroll('prev'));
}


// Виклик функції
initSlider(
  '.item-section',
  '.item-list',
  null,
  null
);

initSlider(
  '.natural-section',
  '.natural-list',
  null,
  null,
  ".slider-pagination"
);
